<app-relatorio-container
    tituloRelatorio="Certidão de Suspensão"
    descricaoRelatorio="Certidão de suspensão da inscrição do prestador"
    categoriaRelatorio="Cadastro"
    [filtrosTemplate]="filtrosTemplate"
    [pdfBlob]="(job$ | async)?.pdfBlob"
    [pdfFileName]="(job$ | async)?.fileName ?? 'certidao-suspensao-pj.pdf'"
    [statusPreview]="(job$ | async)?.status ?? null"
    [progressoPreview]="(job$ | async)?.progress ?? 0"
>
    <ng-template #filtrosTemplate>
        <div class="flex flex-col gap-6" [formGroup]="form">
            <p class="text-sm text-color-secondary m-0">A certidão é emitida para o prestador selecionado. O nome e o cargo do assinante são opcionais: se informados, a certidão exibe o bloco de assinatura correspondente.</p>

            <div class="field">
                <label for="assinante" class="font-semibold block mb-2">Assinante (opcional)</label>
                <input id="assinante" type="text" pInputText formControlName="assinante" class="w-full" placeholder="Nome do assinante" />
            </div>

            <div class="field">
                <label for="cargoAssinante" class="font-semibold block mb-2">Cargo do assinante (opcional)</label>
                <input id="cargoAssinante" type="text" pInputText formControlName="cargoAssinante" class="w-full" placeholder="Cargo do assinante" />
            </div>

            <div class="field pt-5 flex justify-end gap-2">
                <p-button label="Limpar" icon="pi pi-eraser" [variant]="'text'" (click)="limparFormulario()"></p-button>
                <p-button label="Gerar Certidão" icon="pi pi-file-pdf" [appCan]="roleGerar" (click)="gerarRelatorio()" [loading]="isPending" [disabled]="isPending"></p-button>
            </div>
        </div>
    </ng-template>
</app-relatorio-container>
